export default {"src":"/_next/static/media/maestro-logo.d558c6f1.svg","height":124,"width":200,"blurWidth":0,"blurHeight":0};